import { render, staticRenderFns } from "./perfil-del-ciudadano.mobile.vue?vue&type=template&id=8d8e158a&scoped=true&"
import script from "./perfil-del-ciudadano.mobile.vue?vue&type=script&lang=ts&"
export * from "./perfil-del-ciudadano.mobile.vue?vue&type=script&lang=ts&"
import style0 from "./perfil-del-ciudadano.mobile.vue?vue&type=style&index=0&id=8d8e158a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8e158a",
  null
  
)

export default component.exports